export default __webpack_public_path__ + "static/media/section10.8d018f8f.png";